import { GAS_PATH, ELECTRICITY_PATH } from '@utils';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import WatchLaterOutlinedIcon from '@mui/icons-material/WatchLaterOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
// import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
// import DonutSmallOutlinedIcon from '@mui/icons-material/DonutSmallOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import DisplaySettingsOutlinedIcon from '@mui/icons-material/DisplaySettingsOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';

// back office icon imports
import DashboardOutlineIcon from '@mui/icons-material/DashboardOutlined';
import TuneOutlineIcon from '@mui/icons-material/TuneOutlined';
import HourglassBottomOutlinedIcon from '@mui/icons-material/HourglassBottomOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import CloseFullscreenOutlinedIcon from '@mui/icons-material/CloseFullscreenOutlined';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import ModelTrainingOutlinedIcon from '@mui/icons-material/ModelTrainingOutlined';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import FastForwardOutlinedIcon from '@mui/icons-material/FastForwardOutlined';
import FenceOutlinedIcon from '@mui/icons-material/FenceOutlined';

// gas sidebar options
export let gas_trade_pages = {
    header: 'Trade',
    icon: <SwapVertOutlinedIcon />,
    childrens: [
        {
            label: 'EEX',
            link: GAS_PATH.EEX,
            icon: <FolderOutlinedIcon />
        },
        {
            label: 'THE',
            link: GAS_PATH.THE_EUR,
            icon: <FolderOutlinedIcon />
        },
        {
            label: 'TTF',
            link: GAS_PATH.TTF_EUR,
            icon: <FolderOutlinedIcon />
        },
        {
            label: 'PEG',
            link: GAS_PATH.PEG_EUR,
            icon: <FolderOutlinedIcon />
        },
        {
            label: 'Market Place',
            link: GAS_PATH.MARKET_PLACE,
            icon: <FolderOutlinedIcon />
        },
        {
            label: 'Intraday',
            link: GAS_PATH.INTRADAY,
            icon: <WatchLaterOutlinedIcon />
        },
        {
            label: 'Trading Advisor',
            link: GAS_PATH.TRADING_ADVISOR,
            icon: <AutoAwesomeOutlinedIcon />
        }
    ]
};

export let gas_discover_pages = {
    header: 'Discover',
    icon: <ExploreOutlinedIcon />,
    childrens: [
        {
            label: 'Order Logs',
            link: GAS_PATH.ORDERS,
            icon: <LayersOutlinedIcon />
        },
        {
            label: 'Watchlist',
            link: GAS_PATH.WATCHLIST,
            icon: <RemoveRedEyeOutlinedIcon />
        },
        {
            label: 'News Feed',
            link: GAS_PATH.NEWS_FEED,
            icon: <FeedOutlinedIcon />
        },
        {
            label: 'Price Profiling',
            link: GAS_PATH.PRICE_PROFILING,
            icon: <LocalOfferOutlinedIcon />
        },
        {
            label: 'Notifications',
            link: GAS_PATH.NOTIFICATIONS,
            icon: <NotificationsOutlinedIcon />
        }
    ]
};
// export let gas_forecasting_pages = {
//     header: 'Forecasting',
//     icon: <BubbleChartIcon />,
//     childrens: [
//         {
//             label: 'Auto Reporting',
//             link: GAS_PATH.AUTO_REPORTING,
//             icon: <InsightsOutlinedIcon />
//         }
//     ]
// };
export let gas_entry_system_pages = {
    header: 'Portfolio',
    icon: <SettingsSuggestIcon />,
    childrens: [
        {
            label: 'Dashboard',
            link: GAS_PATH.DASHBOARD,
            icon: <DashboardOutlineIcon />
        },
        {
            label: 'Hedges',
            link: GAS_PATH.HEDGES,
            icon: <TuneOutlineIcon />
        },
        {
            label: 'Search',
            link: GAS_PATH.SEARCH,
            icon: <SearchOutlinedIcon />,
            isAdmin: true
        },
        {
            label: 'Forward',
            link: GAS_PATH.FORWARD,
            icon: <FastForwardOutlinedIcon />,
            isAdmin: true
        },
        {
            label: 'Hedge',
            link: GAS_PATH.HEDGE,
            icon: <FenceOutlinedIcon />,
            isAdmin: true
        },
        // {
        //     label: 'Hedge Transfer',
        //     link: GAS_PATH.HEDGE_TRANSFER,
        //     icon: <LocalShippingOutlinedIcon />
        // },
        // {
        //     label: 'Options',
        //     link: GAS_PATH.OPTIONS,
        //     icon: <PlaylistAddCheckOutlinedIcon />
        // },
        {
            label: 'Counterparty',
            link: GAS_PATH.COUNTERPARTY,
            icon: <ModelTrainingOutlinedIcon />,
            isAdmin: true
        },
        {
            label: 'Portfolio',
            link: GAS_PATH.PORTFOLIO,
            icon: <HourglassBottomOutlinedIcon />,
            isAdmin: true
        },
        {
            label: 'Brokers',
            link: GAS_PATH.BROKERS,
            icon: <CloseFullscreenOutlinedIcon />,
            isAdmin: true
        },
        {
            label: 'Exchanges',
            link: GAS_PATH.EXCHANGES,
            icon: <CachedOutlinedIcon />,
            isAdmin: true
        },
        // {
        //     label: 'Endpoints',
        //     link: GAS_PATH.ENDPOINTS,
        //     icon: <AccountTreeOutlinedIcon />
        // }
    ]
};

export let gas_manage_pages = {
    header: 'Manage',
    icon: <DisplaySettingsOutlinedIcon />,
    childrens: [
        {
            label: 'Calendar',
            link: GAS_PATH.CALENDAR,
            icon: <CalendarMonthOutlinedIcon />
        },
        {
            label: 'Help',
            link: GAS_PATH.HELP,
            icon: <HelpOutlineOutlinedIcon />
        },
        {
            label: 'Settings',
            link: GAS_PATH.SETTINGS,
            icon: <SettingsOutlinedIcon />,
            isAdmin: true
        }
    ]
};

export let gas_sidebar_options = [
    gas_trade_pages,
    gas_discover_pages,
    // gas_forecasting_pages,
    gas_entry_system_pages,
    gas_manage_pages
];

// electricity sidebar options
export let electricity_trade_pages = {
    header: 'Trade',
    icon: <SwapVertOutlinedIcon />,
    childrens: [
        {
            label: 'CHE-EUR',
            link: ELECTRICITY_PATH.CHE_EUR,
            icon: <FolderOutlinedIcon />
        },
        {
            label: 'CH-CHF',
            link: ELECTRICITY_PATH.CH_CHF,
            icon: <FolderOutlinedIcon />
        }
    ]
};

export let electricity_discover_pages = {
    header: 'Discover',
    icon: <ExploreOutlinedIcon />,
    childrens: [
        {
            label: 'Calendar',
            link: ELECTRICITY_PATH.CALENDAR,
            icon: <CalendarMonthOutlinedIcon />
        },
        {
            label: 'News Feed',
            link: ELECTRICITY_PATH.NEWS_FEED,
            icon: <FeedOutlinedIcon />
        },
        {
            label: 'Orders',
            link: ELECTRICITY_PATH.ORDERS,
            icon: <LayersOutlinedIcon />
        },
        {
            label: 'Disclaimer',
            link: ELECTRICITY_PATH.DISCLAIMER,
            icon: <WarningAmberOutlinedIcon />
        },
        {
            label: 'Help',
            link: ELECTRICITY_PATH.HELP,
            icon: <HelpOutlineOutlinedIcon />
        }
    ]
};

export let electricity_sidebar_options = [
    electricity_trade_pages,
    electricity_discover_pages
];
